(function () {
  function initProductSliders() {
    if (typeof Swiper === 'undefined' || typeof getSliderSettings === 'undefined') {
      return;
    }

    const mediaList = document.querySelector('.js-media-list');
    const slider = mediaList?.swiper || new Swiper('.js-media-list', getSliderSettings());

    if (typeof getSubSliderProductSettings !== 'undefined') {
      const mediaSublist = document.querySelector('.js-media-sublist');
      const subSlider = mediaSublist?.swiper || new Swiper('.js-media-sublist', getSubSliderProductSettings());
      setTimeout(function () {
        slider.update();
        subSlider.update();
      }, 100);
      return;
    }

    setTimeout(function () {
      slider.update();
    }, 100);
  }

  function initStickyBuyBar(root) {
    const scope = root || document;
    const sticky = scope.querySelector('[data-ardexa-sticky-buy]');
    const submit = scope.querySelector('[data-ardexa-sticky-submit]');
    const productSubmit = scope.querySelector('.product-form__submit');

    if (!sticky || !submit || !productSubmit || typeof IntersectionObserver === 'undefined') {
      return;
    }

    submit.addEventListener('click', function () {
      productSubmit.click();
    });

    const observer = new IntersectionObserver(function (entries) {
      const entry = entries[0];
      sticky.hidden = false;
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }, {
      threshold: 0
    });

    observer.observe(productSubmit);
  }

  function syncPreorderButtons(root) {
    const scope = root || document;
    const form = scope.querySelector('form[data-type="add-to-cart-form"]');
    const submit = scope.querySelector('.product-form__submit');
    const submitLabel = submit && (submit.querySelector('[data-ardexa-submit-label]') || submit.querySelector('span'));
    const stickySubmit = scope.querySelector('[data-ardexa-sticky-submit]');
    const inventory = scope.querySelector('[id^="Inventory-"]');
    const fulfillmentNote = scope.querySelector('[data-ardexa-fulfillment-note]');
    const fulfillmentLabel = fulfillmentNote && (fulfillmentNote.querySelector('[data-ardexa-fulfillment-label]') || fulfillmentNote);

    if (!form || !submit || !submitLabel || !inventory) return;

    const isPreorder = Boolean(inventory.querySelector('.inventory__preorder-note'));
    let preorderInput = form.querySelector('input[name="properties[_ardexa_preorder]"]');
    const setText = function (element, text) {
      if (element && element.textContent.trim() !== text) {
        element.textContent = text;
      }
    };

    if (isPreorder && !preorderInput) {
      preorderInput = document.createElement('input');
      preorderInput.type = 'hidden';
      preorderInput.name = 'properties[_ardexa_preorder]';
      preorderInput.value = '90_days';
      form.appendChild(preorderInput);
    } else if (!isPreorder && preorderInput) {
      preorderInput.remove();
    }

    if (isPreorder) {
      setText(submitLabel, 'Pre ordine');
      setText(stickySubmit, 'Pre ordine');
      setText(fulfillmentLabel, fulfillmentNote?.dataset.preorderDeliveryText || fulfillmentNote?.dataset.preorderNote || '90 giorni lavorativi');
    } else if (!submit.disabled && submit.getAttribute('aria-disabled') !== 'true') {
      setText(submitLabel, window.variantStrings?.addToCart || 'Aggiungi al carrello');
      setText(stickySubmit, 'Aggiungi al carrello');
      setText(fulfillmentLabel, fulfillmentNote?.dataset.deliveryText || fulfillmentNote?.dataset.defaultNote || '');
    }
  }

  function initDeliveryEstimates(root) {
    const scope = root || document;
    const estimates = scope.querySelectorAll('[data-ardexa-delivery-estimate]');
    const monthFormatter = new Intl.DateTimeFormat('it-IT', { month: 'long' });
    const dateFormatter = new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'long' });

    if (!estimates.length) return;

    const isBusinessDay = function (date) {
      const day = date.getDay();
      return day !== 0 && day !== 6;
    };

    const addBusinessDays = function (startDate, days) {
      const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
      let addedDays = 0;

      while (addedDays < days) {
        date.setDate(date.getDate() + 1);
        if (isBusinessDay(date)) addedDays += 1;
      }

      return date;
    };

    const formatDeliveryRange = function (minDate, maxDate) {
      if (minDate.getTime() === maxDate.getTime()) {
        return `Arriva entro ${dateFormatter.format(maxDate)}`;
      }

      if (minDate.getMonth() === maxDate.getMonth() && minDate.getFullYear() === maxDate.getFullYear()) {
        return `Arriva tra ${minDate.getDate()} e ${maxDate.getDate()} ${monthFormatter.format(maxDate)}`;
      }

      return `Arriva tra ${dateFormatter.format(minDate)} e ${dateFormatter.format(maxDate)}`;
    };

    estimates.forEach(function (estimate) {
      const label = estimate.querySelector('[data-ardexa-delivery-label]');
      const minDays = parseInt(estimate.dataset.minBusinessDays || '0', 10);
      const maxDays = parseInt(estimate.dataset.maxBusinessDays || estimate.dataset.minBusinessDays || '0', 10);
      const quoteRequired = estimate.dataset.quoteRequired === 'true';

      if (!label || label.dataset.deliveryReady === 'true') return;
      label.dataset.deliveryReady = 'true';

      if (quoteRequired || minDays <= 0 || maxDays <= 0) {
        label.textContent = 'Consegna da confermare';
        estimate.dataset.deliveryText = label.textContent;
        return;
      }

      const today = new Date();
      const minDate = addBusinessDays(today, minDays);
      const maxDate = addBusinessDays(today, Math.max(minDays, maxDays));
      const preorderDate = addBusinessDays(today, 90);
      estimate.dataset.preorderDeliveryText = formatDeliveryRange(preorderDate, preorderDate);
      label.textContent = formatDeliveryRange(minDate, maxDate);
      estimate.dataset.deliveryText = label.textContent;
    });
  }

  function initProductShare(root) {
    const scope = root || document;
    const buttons = scope.querySelectorAll('[data-ardexa-share-product]');

    buttons.forEach(function (button) {
      if (button.dataset.ardexaShareReady === 'true') return;
      button.dataset.ardexaShareReady = 'true';

      const status = button.querySelector('[data-ardexa-share-status]');
      const setStatus = function (message) {
        if (status) status.textContent = message;
        button.classList.add('is-copied');
        window.setTimeout(function () {
          button.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 1800);
      };

      button.addEventListener('click', function () {
        const shareData = {
          title: button.dataset.shareTitle || document.title,
          url: button.dataset.shareUrl || window.location.href
        };

        if (navigator.share) {
          navigator.share(shareData).catch(function () {});
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareData.url).then(function () {
            setStatus('Link copiato');
          }).catch(function () {
            window.prompt('Copia il link del prodotto', shareData.url);
          });
          return;
        }

        window.prompt('Copia il link del prodotto', shareData.url);
      });
    });
  }

  function initWishlist(root) {
    const scope = root || document;
    const buttons = scope.querySelectorAll('[data-ardexa-wishlist-product]');
    const storageKey = 'ardexa:wishlist';

    if (!buttons.length) return;

    const readWishlist = function () {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey)) || [];
      } catch (error) {
        return [];
      }
    };

    const writeWishlist = function (items) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(items));
      } catch (error) {
        return;
      }
    };

    const applyState = function (button, isSaved) {
      button.classList.toggle('is-saved', isSaved);
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      button.setAttribute('aria-label', isSaved ? 'Rimuovi prodotto dai preferiti' : 'Salva prodotto nei preferiti');
    };

    buttons.forEach(function (button) {
      if (button.dataset.ardexaWishlistReady === 'true') return;
      button.dataset.ardexaWishlistReady = 'true';

      const productId = button.dataset.productId;
      applyState(button, readWishlist().some(function (item) {
        return item.id === productId;
      }));

      button.addEventListener('click', function () {
        const items = readWishlist();
        const currentIndex = items.findIndex(function (item) {
          return item.id === productId;
        });
        const shouldSave = currentIndex === -1;

        if (shouldSave) {
          items.unshift({
            id: productId,
            handle: button.dataset.productHandle,
            title: button.dataset.productTitle,
            url: button.dataset.productUrl,
            savedAt: Date.now()
          });
        } else {
          items.splice(currentIndex, 1);
        }

        writeWishlist(items);
        applyState(button, shouldSave);
        window.dispatchEvent(new CustomEvent('ardexa:wishlist:change', { detail: { productId, saved: shouldSave } }));
      });
    });
  }

  function initPreorderSync(root) {
    const scope = root || document;
    const inventory = scope.querySelector('[id^="Inventory-"]');
    const submit = scope.querySelector('.product-form__submit');

    syncPreorderButtons(scope);

    if (!inventory || inventory.dataset.ardexaPreorderObserver === 'true') return;
    inventory.dataset.ardexaPreorderObserver = 'true';

    const observer = new MutationObserver(function () {
      window.requestAnimationFrame(function () {
        initDeliveryEstimates(scope);
        syncPreorderButtons(scope);
      });
    });

    observer.observe(inventory, { childList: true, subtree: true });

    if (submit) {
      observer.observe(submit, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyBuyBar(document);
    initDeliveryEstimates(document);
    initProductShare(document);
    initWishlist(document);
    initPreorderSync(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductSliders();
    initStickyBuyBar(event.target);
    initDeliveryEstimates(event.target);
    initProductShare(event.target);
    initWishlist(event.target);
    initPreorderSync(event.target);
  });
})();
